// extracted by mini-css-extract-plugin
module.exports = {"breakTabletSmall":"768px","breakTablet":"996px","breakDesktop":"1160px","breakDesktopLarge":"1200px","breakHd":"1440px"};